import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';
import './concrete/ui-shell.min.js';
import './concrete/button.min.js';
import './concrete/icon-button.min.js';
declare global {
  namespace JSX {
    interface IntrinsicElements {
      ['cds-left-panel']: React.DetailedHTMLProps<any, any>;
      ['cds-left-panel-link']: React.DetailedHTMLProps<any, any>;
      ['cds-left-panel-items']: React.DetailedHTMLProps<any, any>;
      ['cds-left-panel-footer']: React.DetailedHTMLProps<any, any>;
      ['cds-left-panel-divider']: React.DetailedHTMLProps<any, any>;
      ['cds-left-panel-menu']: React.DetailedHTMLProps<any, any>;
      ['cds-left-panel-menu-item']: React.DetailedHTMLProps<any, any>;
      ['cds-header']: React.DetailedHTMLProps<any, any>;
      ['cds-header-left']: React.DetailedHTMLProps<any, any>;
      ['cds-header-right']: React.DetailedHTMLProps<any, any>;
      ['cds-button']: React.DetailedHTMLProps<any, any>;
      ['cds-icon-button']: React.DetailedHTMLProps<any, any>;
    }
  }
}
ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
